import React from 'react';

class DataDeliveryParameterTemplate extends React.Component {

  componentWillMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {

  }

  render() {
    return (
      <div>
        ParameterTemplate
      </div>
    );
  }
}

export default DataDeliveryParameterTemplate;


// WEBPACK FOOTER //
// ./src/components/DataDelivery/DataDeliveryParameterTemplate.js